
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import {
	getSearchDate,
	nextDay
} from "@/utils"
import {
	defaultHeader
} from "@/utils/config"
import {
	memberRecordlist
} from "@/api/agent_user"
@Component({
	name: '',
	components: {
		PageFooter,
		PickerDate
	}
})

export default class ProductList extends Vue {
	private keywords = ''
	private type = null
	private typelist = [
		{ value: null, label: '全部' },
		{ value: 11, label: '注册' },
		{ value: 4, label: '注册分销员' },
		{ value: 16, label: '绑定手机号' },
		{ value: 3, label: '授权审核驳回' },
		{ value: 8, label: '编辑资料' },
		{ value: 7, label: '变更等级' },
		{ value: 5, label: '变更上级' },
		{ value: 6, label: '变更推荐人' },
		{ value: 1, label: '拉黑' },
		{ value: 2, label: '恢复' },
		// {value:9,label:'微信授权'},
		// {value:10,label:'修改登录密码'},
		// {value:12,label:'数据变更'},
		// {value:13,label:'锁粉'},
		// {value:14,label:'变更团长'},
		// {value:15,label:'更新定位'},
		// {value:17,label:'取消授权'},
		// {value:18,label:'恢复授权'},
	]
	private filterTime = ''
	private tablelist: any = []
	private tableloading = false
	private pageNo = 1
	private pageSize = 20
	private total = 0
	private defaultHeader = defaultHeader

	private mounted() {
		this.initTime()
		this.gettablelist()
	}


	private initTime() {
		this.filterTime = getSearchDate(1).join('/')
	}
	private clearSearch() {
		this.keywords = ''
		this.type = null
		this.initTime()
		this.doSearch()
	}
	private doSearch() {
		this.pageNo = 1
		this.gettablelist()
	}
	private changePage(e) {
		this.pageNo = e
		this.gettablelist()
	}
	private async gettablelist() {
		try {
			this.tableloading = true
			let data: any = {
				Keywords: this.keywords,
				RecordType: this.type,
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize
			}
			if (this.filterTime) {
				let t = this.filterTime.split('/')
				data.StartTime = t[0]
				data.EndTime = nextDay(t[1], 1)
			}
			let res: any = await memberRecordlist(data)
			if (res.IsSuccess) {
				this.tablelist = res.Result.Results
				this.total = res.Result.Total
			}
		} finally {
			this.tableloading = false
		}
	}

	private handleExport() {
		let times = [];
		let start = '';
		let end = '';
		if (this.filterTime) {
			times = this.filterTime.split('/');
			start = times[0]
			end = nextDay(times[1], 1)
		}
		let url = `${location.origin}/pc/memberRecord/export?RecordType=${this.type||''}&Keywords=${this.keywords}&StartTime=${start}&EndTime=${end}`;
		window.open(url);
	}
}
